import React from 'react';
const TableFilterControlsSection = props => {
    const {children, showDivider = true, ...rest} = props

    return (
        <>
            <div className={'ch-filter-form-section'} {...rest}>
                {children}
            </div>
            {showDivider && <Divider style={{margin: "12px 0 4px 0"}}/>}
        </>
    );
};

import {Divider} from "antd";

export default TableFilterControlsSection;